module.exports = __webpack_public_path__ + "static/media/ico-youtube-hover.7c46789b.svg";